import React, { useState } from "react";
import onequestion from "assets/images/flus/one.png";
import twoquestion from "assets/images/flus/two.png";
import threequestion from "assets/images/flus/three.png";
import aroundTheHorn from "assets/images/flus/Flus-around-the-horn.png";
import flusCard from "assets/images/flus/Fluster-card-icon.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";

const FlusterCard = ({
  onClick = () => {},
  card,
  selected = false,
  isSingleCard = false,
  isFluster = false,
  isAroundTheHorn = false,
  showPoint = true
}) => {
  const isSpecial = card?.special !== "None";
  const handleGetIcon = () => {
    if (card?.special === "None") {
      return card.points === 1
        ? onequestion
        : card.points === 2
        ? twoquestion
        : threequestion;
    }
    if (card?.special === "Fluster") {
      return flusCard;
    }
    if (isFluster) {
      return flusCard;
    }
    if (isAroundTheHorn) {
      return aroundTheHorn;
    } else {
      return aroundTheHorn;
    }
  };

  const iconSrc = handleGetIcon();
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`common-card-wrapper ${selected ? "selected" : ""}${
        isSingleCard ? "single-card" : ""
      }`}
      onClick={onClick}
    >
      {!isSpecial ? (
        <motion.div
          variants={staticBounceVariants}
          className="fluster-card-flex"
        >
          <div className="blank"></div>
          <p className="text">{card?.question}</p>
          <div className="icon-wrapper">
            {showPoint && (
              <div className="icon-circle">
                <img src={iconSrc} className="icon" alt="icon" />
              </div>
            )}
          </div>
        </motion.div>
      ) : (
        <motion.div variants={staticBounceVariants} className="que-flex">
          <p className="que-text">
            {isAroundTheHorn
              ? "AROUND THE HORN"
              : isFluster
              ? "FLUSTER CARD"
              : card?.question}
          </p>
          <img src={iconSrc} className="que-icon" alt="icon" />
        </motion.div>
      )}
    </motion.div>
  );
};

export default FlusterCard;
